import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { REPLAY_REQUEST_TOOL_NAME } from './portal-tool.constants';

export { REPLAY_REQUEST_TOOL_NAME };

export const ReplayRequestActionSchema = z.enum(['send', 'from-history']);

export const ReplayRequestInputSchema = z
  .object({
    action: ReplayRequestActionSchema.default('send'),
    requestId: z.string().optional(),
    method: z.string().optional(),
    url: z.string().optional(),
    headers: z.record(z.string(), z.string()).default({}),
    body: z.string().optional(),
    protocol: z.enum(['http1', 'http2']).optional(),
    followRedirects: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.action === 'from-history') {
      if (!data.requestId) {
        ctx.addIssue({
          code: 'custom',
          message: 'requestId is required for from-history action',
          path: ['requestId'],
        });
      }
      return;
    }

    if (!data.method) {
      ctx.addIssue({
        code: 'custom',
        message: 'method is required for send action',
        path: ['method'],
      });
    }
    if (!data.url) {
      ctx.addIssue({
        code: 'custom',
        message: 'url is required for send action',
        path: ['url'],
      });
    }
  });

export const ReplayFromHistoryToolInputSchema = z.object({
  action: z.literal('from-history').default('from-history'),
  requestId: z.string().min(1),
  protocol: z.enum(['http1', 'http2']).optional(),
  followRedirects: z.boolean().optional(),
});

export const ReplayResponseDataSchema = z.object({
  statusCode: z.number(),
  statusMessage: z.string().optional(),
  headers: z.record(z.string(), z.union([z.string(), z.array(z.string())])),
  body: z.string(),
  durationMs: z.number(),
  sessionId: z.string().optional(),
  error: z.string().optional(),
  sourceRequestId: z.string().optional(),
});

export const ReplayRequestOutputSchema = createPortalToolOutputSchema({
  dataSchema: ReplayResponseDataSchema,
});

export type ReplayRequestInput = z.infer<typeof ReplayRequestInputSchema>;
export type ReplayFromHistoryToolInput = z.infer<
  typeof ReplayFromHistoryToolInputSchema
>;
export type ReplayRequestOutput = z.infer<typeof ReplayRequestOutputSchema>;
export type ReplayResponseData = z.infer<typeof ReplayResponseDataSchema>;
